import { gatewayInstance } from "../axiosInstance";
import { SERVICE_ENDPOINT } from "../const";


export const searchVehicleInOut = async(data) => {
    try{
        const response = await gatewayInstance.post(`${SERVICE_ENDPOINT.REPORT}/reports/vehicle-inout/search`,data);
        return response.data;
    }catch (error){
        console.error(error);
    }
}